import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { PasswordValidator, PasswordValidity } from 'record-it-utils/password/PasswordValidator/PasswordValidator';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import { IconDeprecated, IconSize, IconType } from '../IconDeprecated/IconDeprecated';
import { MessageBoxType } from '../MessageBox/MessageBox';
import { MessageListBox, MessageListBoxProps } from '../MessageListBox/MessageListBox';
import { MessageListBoxListItem } from '../MessageListBoxListItem/MessageListBoxListItem';
import styles from './PasswordRulesBox.module.css';
export type PasswordRulesBoxProps = Omit<MessageListBoxProps, 'type'> & {
  passwordValidity: PasswordValidity;
};
export const PasswordRulesBox: FunctionComponent<PasswordRulesBoxProps> = React.memo(props => {
  const $ = _c(21);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let passwordValidity;
  let remainingProps;
  if ($[2] !== t0) {
    ({
      passwordValidity,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = passwordValidity;
    $[4] = remainingProps;
  } else {
    passwordValidity = $[3];
    remainingProps = $[4];
  }
  const {
    t
  } = useTranslation("record-it-components");
  const t1 = passwordValidity.valid ? MessageBoxType.Success : MessageBoxType.Error;
  const t2 = passwordValidity.hasRequiredLength ? styles.passwordRuleValid : styles.passwordRuleInvalid;
  let t3;
  if ($[5] !== t2) {
    t3 = classes(styles.passwordRule, t2);
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = passwordValidity.hasRequiredLength ? "check" : "xmark";
  let t5;
  if ($[7] !== t4) {
    t5 = <IconDeprecated name={t4} type={IconType.Regular} size={IconSize.Small} className={styles.passwordRuleIcon} />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("misc.PasswordRulesBox.requiredLength", {
      requiredLength: PasswordValidator.REQUIRED_LENGTH
    });
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <span className={styles.passwordRuleText}>{t6}</span>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t5 || $[15] !== t7) {
    t8 = <MessageListBoxListItem className={t3} data-testid="PassworRulesBox.RequiredLengthRule">{t5}{t7}</MessageListBoxListItem>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== remainingProps || $[18] !== t1 || $[19] !== t8) {
    t9 = <MessageListBox type={t1} {...remainingProps}>{t8}</MessageListBox>;
    $[17] = remainingProps;
    $[18] = t1;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
});